<template>
	<svg
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="1em"
		viewBox="0 0 760 568"
	>
		<polygon fill="#FBAC30" points="470.5,567.31 0.47,284 470.5,0.69" />
		<polygon fill="#12B17D" points="470.5,567.31 356.27,466.45 470.5,414.65" />
		<polygon fill="#12B17D" points="356.27,101.55 470.5,0.69 470.5,153.35" />
		<polygon fill="#BB255C" points="759.53,284 356.27,466.45 356.27,101.55" />
		<path
			d="M189.48,294.52h-24.31l12.16-41.96L189.48,294.52z M246.02,344.09l-45.31-130.19h-46.78l-45.31,130.19h42.18l4.42-15.22
		h44.2l4.42,15.22H246.02z"
		/>
		<polygon
			points="309.28,344.09 354.59,213.91 312.41,213.91 285.89,301.54 259.37,213.91 217.19,213.91 262.5,344.09"
		/>
		<polygon
			fill="#FFFFFF"
			points="459.92,344.09 459.92,295.49 514.62,295.49 514.62,261.14 459.92,261.14 459.92,248.26
		515.91,248.26 515.91,213.91 422.71,213.91 422.71,344.09"
		/>
		<rect x="368.33" y="213.91" fill="#FFFFFF" width="37.2" height="130.19" />
	</svg>
</template>
